import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { withStyles, Grid, Typography } from '@material-ui/core'

import homeBannerImg1 from '../images/sign_in/home_banner_1.jpg'
import homeBannerImg3 from '../images/sign_in/home_banner_3.jpg'
import homeBannerImg4 from '../images/sign_in/home_banner_4.jpg'

import SearchBox from './SearchBox'
import * as actions from '../actions'
import { isOnline } from '../utils'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  demo: {
    height: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    maxWidth: '100%',
    margin: 0,
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      height: 257,
    },
  },
  paper: {
    height: '50px',
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('xs')]: {
      height: '36px',
      minWidth: '290px',
    },
  },
  control: {
    padding: theme.spacing.unit * 2,
  },
  bannerWrapper: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  bannerContent: {
    width: '600px',
    padding: '0 !important',
    flex: 'none',
    [theme.breakpoints.down('601')]: {
      maxWidth: '100%',
      width: 'auto',
      padding: '15px !important',
    },
  },
  bannerMarketingContent: {
    maxWidth: '100%',
  },
  bannerTitle: {
    fontSize: 30,
    fontWeight: 500,
    lineHeight: '1.36',
    textAlign: 'center',
    color: '#ffffff',
    padding: '0',
    margin: '0 -30px 15px',
    [theme.breakpoints.down('767')]: {
      fontSize: '20px',
      lineHeight: '100%',
      margin: '0 0 15px',
    },
  },
  contentClass: {
    outline: '0',
    flex: 'none',
  },

  homebannerpara: {
    fontSize: '20px',
    fontWeight: '500',
    flex: 'none',
    color: '#fff',
    lineHeight: '1.7',
    margin: '0 0 19px',
    textAlign: 'center',
    [theme.breakpoints.down('767')]: {
      fontSize: '13px',
      margin: '10px 0 19px',
      lineHeight: '100%',
    },
  },
  bannerMarketingTitle: {
    fontSize: '40px',
    margin: '0',
    [theme.breakpoints.down('sm')]: {
      fontSize: '40px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
    },
  },
  searchbarWrapper: {
    minHeight: '50px',
    [theme.breakpoints.down('xs')]: {
      minHeight: '36px',
    },
  },
  suggestionSection: {
    width: '100%',
    height: 'auto',
    maxHeight: '0',
    padding: '0',
    backgroundColor: '#ffd200',
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.04)',
    transition: 'all 0.7s ease',
    overflow: 'hidden',
    zIndex: -1,
  },
  transit: {
    maxHeight: '1000px',
    padding: '40px 20px 20px',
  },
  suggestionList: {
    padding: '0 35px 20px',
  },
  suggestionListItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '30px',
    justifyContent: 'space-between',
    '& > span': {
      opacity: '0.7',
      fontSize: '15px',
      fontWeight: '500',
      lineHeight: '1.33',
      color: '#000000',
    },
    '& > p': {
      opacity: '0.5',
      fontSize: '15px',
      lineHeight: '1.33',
      color: '#000000',
    },
  },
  carret: {
    transition: 'all 1s ease',
    transform: 'rotateZ(180deg)',
  },
  transform0: {
    transform: 'rotateZ(0deg)',
  },
  searchInputWrapper: {
    '& > input': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
      },
    },
  },
  suggestionitems: {
    backgroundColor: '#ffffff',
  },
  suggestionLi: {
    height: '40px',
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '40px',
    width: '100%',
    padding: '0px 13px 0px 12px',
    margin: '-10px -13px',
    borderRadius: '4px',
    textOverflow: 'elipses',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: 'rgba(29, 187, 176, 0.13)',
      color: '#00bcb5',
    },
  },
})

class SearchBar extends React.Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      bannerImages: [homeBannerImg1, homeBannerImg3, homeBannerImg4],
      bannerImgNumber: this.getRandomNumber(),
    }
    this.intervalId = null
  }

  componentDidMount() {
    this.showRandomBannerImages()
  }

  componentWillUnmount() {
    this.intervalId && clearInterval(this.intervalId)
  }

  getRandomNumber = () => Math.floor(Math.random() * 3)

  showRandomBannerImages = () => {
    this.intervalId = setInterval(() => {
      if (isOnline()) {
        let randomNumber = this.getRandomNumber()
        while (randomNumber === this.state.bannerImgNumber) {
          randomNumber = this.getRandomNumber()
        }

        this.setState({ bannerImgNumber: randomNumber })
      }
    }, 2 * 60 * 1000)
  }

  render() {
    const { classes, withoutSearchBox, aboutUs, pricing } = this.props
    const { bannerImages, bannerImgNumber } = this.state
    const titleClass = withoutSearchBox ? `${classes.bannerTitle} ${classes.bannerMarketingTitle}` : `${classes.bannerTitle}`
    const contentClass = withoutSearchBox ? `${classes.bannerContent} ${classes.bannerMarketingContent}` : `${classes.bannerContent}`
    return (
      <Grid container className={classes.root}>
        <Grid
          item
          xs={12}
          className={classes.bannerWrapper}
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.42), rgba(0, 0, 0, 0.44) 81%, rgba(0, 0, 0, 0.9)), url(${
              bannerImages[bannerImgNumber]
            })`,
          }}>
          <Grid container spacing={16} className={classes.demo}>
            <Grid item xs={12} className={contentClass}>
              {!pricing && (
                <Typography variant="headline" className={titleClass}>
                  {aboutUs ? 'Fast, Fair Deals You Can Trust' : 'A Smarter Way To Buy Investment Properties'}
                </Typography>
              )}
              {pricing && <h3 className={titleClass}>Select The Membership Level That’s Best For You.</h3>}
              {/* {!withoutSearchBox && <div className={classes.homebannerpara}>Our firm offer will not change before closing.</div>} */}
              {!withoutSearchBox && <SearchBox />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

SearchBar.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const searchBar = connect(
  null,
  mapDispatchToProps
)(SearchBar)
export default withStyles(styles)(withRouter(searchBar))



// WEBPACK FOOTER //
// ./src/components/SearchBar.js